// extracted by mini-css-extract-plugin
export default {"container":"Experience_container__fmXJ7","experience__box":"Experience_experience__box__huTEa"};